
import { Vue, Component, Prop } from "vue-property-decorator";
import { Subscription, Subscription_Plan } from "@/generated/graphql";

@Component({})
export default class PriceCardViewPricing extends Vue {
  @Prop({ type: Number, default: undefined }) readonly managersCount!: number;
  @Prop({ type: String, default: undefined }) readonly price!: string;
  @Prop({ type: Boolean, default: false }) readonly basic!: boolean;
  @Prop({ type: Object, default: undefined }) readonly currentSubscription?: Subscription;
  @Prop({ type: Array, required: true }) readonly generalSubscriptionPlans!: string[];
  @Prop({ type: Boolean, required: true }) readonly checkIfPlanIsPremium!: boolean;


  get manyManagers(): string {
    return this.managersCount === 1 ? "" : "s";
  }

}
